<template>
  <div class="menu">
    <div class="menuItems">
      <div
        v-for="repo in repos"
        :key="repo.id"
      >
        <ReposListItem :repo="repo" />
        <div
          v-if="repo.id == currentRepoId"
          class="navMenu"
        >
          <div class="menu submenu">
            <div class="menuItems">
              <router-link
                v-for="menuItem in menuItems"
                :key="menuItem.routeName"
                :to="{ name: menuItem.routeName, params: menuItem.routeParams }"
                class="menuItem"
              >
                {{ menuItem.label }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import ReposListItem from './ReposListItem'

export default {
  name: 'ReposList',
  components: {
    ReposListItem,
  },
  props: {
    repos: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentRepoId: state => state.repos.currentRepoId,
      menuItems: state => state.appFrame.menuItems,
      currentNav: state => state.appFrame.currentNav,
    }),
  },
}

</script>
